import * as React from 'react';
import { forwardRef, useEffect, useImperativeHandle } from 'react';

export type TextAreaFormControlType = HTMLTextAreaElement;
export type TextAreaFormControlProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextAreaFormControl = forwardRef<TextAreaFormControlType, TextAreaFormControlProps>((props, ref) => (
  <textarea ref={ref} className="form-control" {...props} />
));
